module.exports = __webpack_public_path__ + "static/media/line-blue.aa395ecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/line-blue.svg
// module id = 805
// module chunks = 0